import hotelStatement from '@/services/utils/pdf/hotelStatement';
import handleBarcode from "@/services/modules/barcode";
import { useStore } from "vuex";
import useDate from '@/services/utils/day';

const hotelStatementHelper = () => {
    const { exportToPDF } = hotelStatement();
    const { fetchBarcode } = handleBarcode();
    const store = useStore();
    const { formatDate } = useDate();

    const generatePdf = async (company, statement, service, receiptGenerals, total) => {
        const userName = store.state.user.user.name;
        let qrcodeData = JSON.stringify({
            ref_no: statement.admission_no,
            ref_date: statement.admission_date,
            created_by: userName,
            created_date_time: formatDate(new Date())
        })

        var barCodeQuery = `?code=${statement.patient.patient_id}&qrcode=${qrcodeData}`;

        try {
            const res = await fetchBarcode(barCodeQuery);
            const barcode = res.barcode;
            const qrcode = res.qrcode;

            exportToPDF(company, statement, service, receiptGenerals, total, userName, barcode, qrcode);
        } catch (e) {
            return;
        }
    }

    return {
        generatePdf
    }
}

export default hotelStatementHelper;
